import { createContext, useContext } from 'react';
import type { UserProfile } from '@/types/api';
import type { LoginInput, RegisterInput, OAuthProvider } from '@/lib/api';

export type AuthStatus = 'loading' | 'authenticated' | 'unauthenticated';

export interface AuthContextValue {
  readonly status: AuthStatus;
  readonly user: UserProfile | null;
  login: (input: LoginInput) => Promise<void>;
  register: (input: RegisterInput) => Promise<void>;
  signOut: () => Promise<void>;
  signInWithProvider: (provider: OAuthProvider, returnTo?: string) => void;
  /** Called by the OAuth callback route after exchanging the one-time code. */
  completeOAuth: (code: string) => Promise<void>;
}

export const AuthContext = createContext<AuthContextValue | null>(null);

export function useAuth(): AuthContextValue {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error('useAuth must be used inside <AuthProvider>');
  return ctx;
}
